

if (document.querySelectorAll('.comp-content-recruitment')) {
    

    const files = document.querySelectorAll('.file-input');
    files.forEach((file) => {
        
        var label = file.closest('.wrapper').querySelector('label'),
        label_text = label.querySelector('span'),
        label_remove = file.closest('.wrapper').querySelector('i.remove'),
        label_default = label_text.textContent;
        
        // on file change
        file.addEventListener('change', (e) => {
            
            var file_name = file.value.split( '\\' ).pop();
            if( file_name ){    
                label_text.textContent = file_name;
                label_remove.hidden = false;
            }else{
                label_text.text(labelDefault);
                label_remove.hidden = show;
            }

        })
        
        // Remove file 
        label_remove.addEventListener('click', (e) => {
            label_remove.value = false;
            label_text.textContent = label_default;
            label_remove.hidden = show;
        });

    });

    
    let post_select = document.querySelector('#post-select');
    
    const annonces = document.querySelectorAll('.comp-pofil-card');
    annonces.forEach((annonce) => {

        const title = annonce.querySelector('.offre-title').textContent;
        const ref = annonce.querySelector('.offre-title').dataset.ref;

        var option = document.createElement("option");
        option.value = ref + ' - ' + title;
        option.text = title;
        option.id = 'ref' + ref;

        post_select.add(option, null);


    })

    const btns_postuler = document.querySelectorAll('.js-postuler');
    btns_postuler.forEach((btn_postuler) => {

        btn_postuler.addEventListener('click', (e) => {
            
            e.preventDefault();
            const index = parseInt(btn_postuler.dataset.index);
            console.log(index);
            post_select.selectedIndex = index + 2;

        })

    })

}
